import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Container, Box, VStack, Center, Text, Flex, Spacer, Link, Image, HStack, Tooltip } from "@chakra-ui/react"
import LottieControl from './components/AnimationExample';
import LogoReveal from './components/LogoReveal';
import CarRotate from './components/CarRotate';
import { SuccessToast, InfoToast, ErrorToast} from './components/Toast';
import HScrolling from './components/ScrollTrigger';
import WhiteBall from './components/WhiteBall';
import ContactModal from './components/ContactModal';
import ContactPopover from './components/ContactPopover';
import BlackwhiteParallax from './components/BlackwhiteParallax';
import SideParallax from './components/SideParallax';
import Nav from './components/NavigationBar';

const App = () => {
  
  return (
    
    <Container maxW='100%' h='100%' bg='white' paddingInline='0px'>
        {/* NavBar */}
        <Box w='full' h='200px' pos='fixed' zIndex='4'>
          <Nav/>
        </Box>
        {/* LaptopOpening */}
        <Box w='full' h='1500px' bg='white'>
          <Center maxW='full' bg='white' position='sticky' top="0" paddingTop='100px'>
            <Box w='1280px' h='720px'>
              <LottieControl/>
            </Box>
          </Center>
        </Box>
        {/* InteractiveUI */}
        <Box bg='white' w='100%' h='800px' zIndex='2'>
            <Box w='100%' h='250px' bg='white' paddingLeft='10%' textAlign='left'>
              <Text fontWeight="thin" fontSize="500%" lineHeight='1' color='gray.700' paddingLeft='15%'>Interactive UI</Text>
              <Text fontWeight="thin" fontSize="500%" lineHeight='1.3' color='gray.700' paddingLeft='15%'>Immersive UX</Text>
              <Text fontWeight="bold" fontSize="250%" lineHeight='2' color='gray.600' paddingLeft='15%'>[re]Define.</Text>
            </Box>
            <Center>
              <LogoReveal/>
            </Center>
        </Box>
        {/* ParallaxBlackwhite */}
        <Box w='100%' h='750px'>
          <BlackwhiteParallax/>
        </Box>
        {/* //Button API */}
        <Box w='100%' h='700px' bg='white' zIndex='2' textAlign='left'>
            <Text fontWeight="semibold" fontSize="40px" lineHeight='1.5' color='gray.700' paddingLeft='15%'>
              But of course,
            </Text>
            <Text fontWeight="light" fontSize="200%" lineHeight='1.4' color='gray.700' paddingLeft='15%'>
              I can provide you fully functional UI working with API too.
            </Text>
            <Text fontWeight="bold" fontSize="20px" lineHeight='1.5' color='gray.400' paddingLeft='15%'>
              ("Simplicity" and elegant UX really is popular right now.)
            </Text>
            <Flex w='100%' paddingTop='200px' paddingInline='30%'>
              <SuccessToast/> <Spacer/> <InfoToast/> <Spacer/> <ErrorToast/> <Spacer/> <ContactPopover/>
            </Flex>
        </Box>
        {/* SideParallax */}
        <Box w='100%' h='170vh' bg='white'>
          <SideParallax/>
        </Box>
        {/* 3DCar */}
        <Box w='100%' h='900px' bg='white'>
            <Center>
              <Box w='100%' h='100vh' bg='white'>
                <VStack>
                <Text fontWeight="semibold" fontStyle='italic' fontSize="22px"  lineHeight='1' color='gray.700'>
                  and here's a touch of simplicity. 
                </Text>
                <Text fontWeight="light" fontStyle='italic' fontSize="18px"  lineHeight='1' color='gray.700'>
                  (use your mouse.)
                </Text>
                <CarRotate/>
                </VStack>
              </Box>
            </Center>
        </Box>
        <HScrolling/>
        <Box w='100%' h='900px'>  
          <Center w='100%'>
            <Box zIndex='2' paddingTop='50%' pos='absolute' fontWeight='thin' fontSize='30px' color='gray.700'>ready for the ride?</Box>
            <Box zIndex='2' paddingTop='60%' pos='absolute'  ><ContactModal/></Box>
          </Center>
          <WhiteBall/>
        </Box>
        <Box id='contact' w='100%' h='50px' bg='gray.700'>
          <HStack zIndex='3' pos='absolute' paddingTop='10px' paddingLeft='12%' spacing='25%'>
            <Tooltip label="Back to Start." placement="top-start">
              <Link _hover={{ color:'gray.400' }} fontSize='100%' fontWeight='light' color="white" href="#">Home</Link>
            </Tooltip>
            <Tooltip label="See weapons in my Armory." placement="top-start">
              <Link _hover={{ color:'gray.400' }} fontSize='100%' fontWeight='light' color="white" href="#skills">Skills</Link>
            </Tooltip>
            <Tooltip label="You're here." placement="top-start">
              <Link _hover={{ color:'gray.400' }} fontSize='100%' fontWeight='light' color="white" href="#contact">Contact</Link>
            </Tooltip>
          </HStack>
        </Box> 
    </Container>
  )
}
export default App;

// NavBar
// <Box w='full' h='45px' bg='gray.700' pos='fixed' zIndex='4'>
//           <Flex paddingInline='12%'>
//             <Box h='42px'>
//               <Link _hover={{ color:'dogderblue' }} href="#">
//                 <Image h='100%' src={logoHeader}/>
//               </Link>
//             </Box>
//             <Spacer />
//               <HStack spacing='30%' paddingRight='20%'>
//                 <Link _hover={{ color:'blue.200' }} fontSize='120%' fontWeight='semibold' color="white" href="#">Home</Link>
//                 <Link _hover={{ color:'blue.200' }} fontSize='120%' fontWeight='semibold' color="white" href="#skills">Skills</Link>
//                 <Link _hover={{ color:'blue.200' }} fontSize='120%' fontWeight='extrabold' color="white" href="#contact">Contact</Link>
//               </HStack>
//           </Flex>
//         </Box> 